import FeaturesMap from '../constants/FeaturesMap';
// @ts-expect-error not migrated to TS
import { getUserLanguage } from './getUserLanguage';
export const getLangEligibleFeatureIds = featureIds => {
  const languageToFilter = getUserLanguage();
  const filteredFeatureIds = featureIds.filter(featureId => {
    const featureMap = FeaturesMap[featureId];
    const shouldHideFeatureByLanguage = featureMap && featureMap.hideFromLang && featureMap.hideFromLang.includes(languageToFilter);
    return !shouldHideFeatureByLanguage;
  });
  return filteredFeatureIds;
};